import _ from 'lodash';
import { parse } from 'query-string';
import { useMemo } from 'react';
/**
 * パラメータの値をarrayに整形
 * @param {{ search: string, queryName: string }} options
 * @returns {{ids: *, viewParams: {slideId: *, pageId}[]}}
 */
export const useSlideSearchSlideViewParams = (options) => {
    const { id, queryName = 'view', search } = options;
    const viewParams = useMemo(() => {
        var _a;
        const view = ((_a = parse(search)) === null || _a === void 0 ? void 0 : _a[queryName]) || null;
        let values;
        try {
            values = JSON.parse(view) || [];
        }
        catch (_b) {
            values = [];
        }
        return _(values)
            .filter((v) => v.slideId && v.pageId)
            .map((v) => ({
            pageId: v.pageId,
            slideId: v.slideId,
        }))
            .uniqBy('slideId')
            .value();
    }, [search, queryName]);
    const ids = useMemo(() => _(viewParams.map((v) => v.slideId))
        .concat([id])
        .uniq()
        .value(), [id, viewParams]);
    return {
        ids,
        viewParams,
    };
};
export default useSlideSearchSlideViewParams;
